import Image from 'next/image';
import Link from 'next/link';
import logo from '../../../public/assets/logo.png';

/**
 *
 */
export default function Footer() {
  return (
    <>
      <footer className={'my-32 mb-16 px-8 xl:px-0'}>
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="mx-auto max-w-7xl lg:pt-16">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="space-y-8 xl:col-span-1">
              <div className={'relative h-10 w-10'}>
                <Image src={logo} placeholder={'blur'} alt={'Plunk logo'} />
              </div>

              <p className="text-sm text-neutral-500">The Open-Source Email Platform</p>
              <div className="flex space-x-6">
                <Link
                  href="https://twitter.com/useplunk"
                  target={'_blank'}
                  className="text-neutral-400 hover:text-neutral-500"
                >
                  <span className="sr-only">Twitter</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </Link>

                <Link
                  href="https://github.com/useplunk"
                  target={'_blank'}
                  className="text-neutral-400 hover:text-neutral-500"
                >
                  <span className="sr-only">GitHub</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fillRule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </Link>

                <Link href="/discord" target={'_blank'} className="text-neutral-400 hover:text-neutral-500">
                  <span className="sr-only">Discord</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
                  </svg>
                </Link>

                <Link
                  href={'https://app.trypile.com/community/bfa58879-8d65-4e1a-8237-5ffa161fc7a5'}
                  target={'_blank'}
                  className="text-neutral-400 hover:text-neutral-500"
                >
                  <span className="sr-only">Pile</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={'h-6 w-6'}
                    viewBox="0 0 350 350"
                    fill="currentColor"
                  >
                    <path d="M264.521 271.611V132.19C264.521 131.716 264.294 131.555 263.839 131.707C260.742 132.815 258.123 133.914 255.982 135.003C241.291 142.514 226.785 150.021 212.464 157.522C209.338 159.161 206.151 160.695 202.902 162.126C190.726 167.51 179.104 174.174 167.24 180.169C166.445 180.567 165.63 180.605 164.797 180.283L120.142 162.95C120.043 162.913 119.937 162.901 119.832 162.914C119.728 162.927 119.628 162.965 119.542 163.025C119.455 163.085 119.384 163.165 119.336 163.258C119.287 163.352 119.261 163.455 119.261 163.561L119.289 185.043C119.289 185.554 119.516 185.919 119.971 186.137C124.707 188.429 129.22 190.243 133.511 191.578C144.323 194.931 154.425 198.938 164.569 203.271C164.899 203.414 165.256 203.484 165.614 203.477C165.972 203.469 166.323 203.385 166.644 203.229C179.345 197.119 191.948 190.944 204.451 184.702C217.508 178.195 231.63 170.338 245.525 163.717C246.274 163.357 246.648 163.594 246.648 164.427C246.553 199.71 246.525 238.005 246.563 279.312C246.563 279.368 246.577 279.42 246.605 279.468C246.69 279.591 246.785 279.676 246.889 279.724C246.823 280.396 246.586 280.827 246.179 281.016C235.76 285.942 225.057 291.312 214.069 297.128C204.124 302.395 188.424 310.062 166.97 320.131C166.678 320.267 166.342 320.283 166.033 320.173L73.8951 285.705C73.4594 285.535 73.2368 285.217 73.2273 284.753L73 253.652L164.896 288.589C165.219 288.715 165.564 288.773 165.909 288.761C166.253 288.749 166.59 288.666 166.899 288.518C188.505 278.364 209.897 267.652 231.076 256.38C231.247 256.295 231.332 256.158 231.332 255.968L231.289 233.96C231.287 233.882 231.266 233.806 231.228 233.738C231.189 233.67 231.134 233.614 231.068 233.574C231.003 233.534 230.928 233.512 230.853 233.51C230.777 233.508 230.702 233.526 230.636 233.562C220.188 239.103 210.048 244.365 200.217 249.347C195.897 251.549 191.337 252.899 187.202 255.258C180.61 259.037 173.591 262.248 166.871 265.615C166.548 265.777 166.194 265.869 165.832 265.886C165.47 265.903 165.108 265.845 164.768 265.715L73.1989 230.863L73.1705 211.512L165.265 246.52C165.739 246.7 166.208 246.676 166.672 246.449L230.735 214.183C231.095 214.003 231.275 213.714 231.275 213.316L231.204 191.763C231.204 191.299 230.981 191.147 230.536 191.308C222.523 194.193 215.661 198.37 208.201 202.149C195.14 208.77 183.215 214.983 172.426 220.79C165.422 224.54 163.077 222.48 155.434 219.568C134.567 211.611 114.392 203.802 94.9084 196.139C88.4865 193.61 80.4023 191.521 73.1989 188.538L73.1847 125.825L164.711 160.861C165.498 161.164 166.27 161.126 167.027 160.747L263.555 111.844C264.199 111.513 264.521 110.987 264.521 110.267L264.408 88.8275C264.407 88.7694 264.391 88.7125 264.362 88.6621C264.333 88.6118 264.292 88.5697 264.242 88.5398C264.192 88.5099 264.136 88.4932 264.078 88.4914C264.019 88.4895 263.962 88.5025 263.91 88.5291L167.596 137.262C167.094 137.513 166.548 137.657 165.99 137.687C165.433 137.716 164.876 137.629 164.356 137.432L73.3552 103.092L73.1421 72.0623C73.1421 71.3898 73.4404 70.8972 74.0372 70.5847C91.3612 61.3307 107.099 53.2701 121.25 46.403C122.737 45.6831 124.153 44.9775 125.498 44.286C135.462 39.1996 145.436 34.1701 155.419 29.1973C155.893 28.9605 156.381 28.9369 156.883 29.1263L276.925 75.0743C277.427 75.2638 277.678 75.6284 277.678 76.1683L277.706 264.337C277.706 264.905 277.45 265.312 276.939 265.558L264.521 271.611Z" />
                  </svg>
                </Link>
              </div>
            </div>
            <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 xl:col-span-2 xl:mt-0">
              <div>
                <div>
                  <ul role="list" className="mt-4 space-y-4">
                    <li>
                      <Link href={'/pricing'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Pricing
                      </Link>
                    </li>

                    <li>
                      <Link href={'/made-by-humans'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Made by humans
                      </Link>
                    </li>

                    <li>
                      <Link href={'/use-cases'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Use cases
                      </Link>
                    </li>

                    <li>
                      <Link href={'/jsx-email'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        JSX Email
                      </Link>
                    </li>

                    <li>
                      <Link href={'/discord'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Discord
                      </Link>
                    </li>

                    <li>
                      <Link href={'/blog'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Blog
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <div>
                  <ul role="list" className="mt-4 space-y-4">
                    <li>
                      <Link href={'/markdown-to-email'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Markdown to HTML
                      </Link>
                    </li>

                    <li>
                      <Link href={'/email-validator'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Email Validator
                      </Link>
                    </li>

                    <li>
                      <Link href={'/spam-checker'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Spam Checker
                      </Link>
                    </li>

                    <li>
                      <Link href={'/glossary'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Glossary
                      </Link>
                    </li>

                    <li>
                      <Link
                        target={'_blank'}
                        href={'https://docs.useplunk.com'}
                        className="text-sm text-neutral-500 hover:text-neutral-800"
                      >
                        Docs
                      </Link>
                    </li>

                    <li>
                      <Link
                        href={'https://status.useplunk.com'}
                        target={'_blank'}
                        className="text-sm text-neutral-500 hover:text-neutral-800"
                      >
                        Status
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <div>
                  <ul role="list" className="mt-4 space-y-4">
                    <li>
                      <Link href={'/privacy'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Privacy Policy
                      </Link>
                    </li>

                    <li>
                      <Link href={'/terms'} className="text-sm text-neutral-500 hover:text-neutral-800">
                        Terms of Service
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="pt-12">
            <p className="text-sm text-neutral-400 xl:text-center">
              &copy; {new Date().getFullYear()} Plunk. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
